<script>
import { Line, mixins } from 'vue-chartjs';
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';
const { reactiveProp } = mixins;

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    type : {
      type: String,
    },
    data: []
  },
  data: () => ({
    marketChartData: {
      labels: [],
      datasets: [
        {
          order: 1,
          type: 'line',
          label: 'Giá cao',
          backgroundColor: 'transparent',
          borderColor: '#4f81bd',
          tension: 0,
          pointStyle: 'rect',
          pointRadius: 5,
          pointBackgroundColor: "#4f81bd",
          data: []
        },
        {
          order: 2,
          type: 'line',
          label: 'Giá thấp',
          backgroundColor: 'transparent',
          borderColor: '#c0504d',
          tension: 0,
          pointStyle: 'rect',
          pointRadius: 5,
          pointBackgroundColor: "#c0504d",
          data: []
        },
      ]
    },
    options: {
      scales: {
        xAxes: [{
          scaleLabel: {
            display: true,
            labelString: 'Tháng trong năm'
          }
        }],
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: 'Giá (Ngàn đồng)'
          },
          ticks: {
            beginAtZero: true,
            callback: function(value, index, values) {
              if(parseInt(value) >= 1000){
                return (value/1000).toString();
              } else {
                return value;
              }
            }
          }
        }]
      },
      tooltips: {
        callbacks: {
          title: function(tooltipItem, data) {
            return `Tháng ${data['labels'][tooltipItem[0]['index']]}`;
          },
          label: function(tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label || '';
            if (label) {
              label += ': ';
            }
            let value_tmp = Math.round(tooltipItem.yLabel * 100) / 100;
            let value = value_tmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            label += `${value} đ`;
            return label;
          }
        }
      },
      plugins: {
        datalabels: {
          formatter: (value) => {
            if(parseInt(value) >= 1000){
              return (value/1000).toString() + 'k';
            } else {
              return value + 'k';
            }
          },
          display: function(context) {
            return context.dataset.order !== 1
          },
          color: 'black',
        }
      },
    }
  }),
  watch: {
    data(){
      this.init();
    }
  },
  mounted() {
    Chart.plugins.register(ChartJsPluginDataLabels);
    this.addPlugin(ChartJsPluginDataLabels);
    this.init();
  },
  methods: {
    init(){
      const app = this;
      app.marketChartData.labels = [];
      app.marketChartData.datasets[0].data = [];
      app.marketChartData.datasets[1].data = [];

      app.data.forEach(function(el){
        if(app.type == 'month'){
          app.marketChartData.labels.push(`Tháng ${el.thang}`);
        } else {
          app.marketChartData.labels.push(`${el.ngay} Tháng ${el.thang} (Tuần ${el._week})`);
        }
        app.marketChartData.datasets[0].data.push(el.h_price_tb);
        app.marketChartData.datasets[1].data.push(el.l_price_tb);
      })
      app.renderChart(app.marketChartData, app.options);
      app.$emit('finish');
    }
  }
}
</script>